import { render, staticRenderFns } from "./userResultCard.vue?vue&type=template&id=18c93aa9&scoped=true&"
import script from "./userResultCard.vue?vue&type=script&lang=js&"
export * from "./userResultCard.vue?vue&type=script&lang=js&"
import style0 from "./userResultCard.vue?vue&type=style&index=0&id=18c93aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c93aa9",
  null
  
)

export default component.exports